import { MarketingAttributionEvent } from "@redotech/redo-marketing-templates-common/marketing";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { ChannelFilter } from "../filters/marketing-channel-filter";
import { MarketingAnalyticsAutomationPerformance } from "./marketing-analytics-automation-performance";
import { MarketingAnalyticsCampaignPerformance } from "./marketing-analytics-campaign-performance";
import { MarketingAnalyticsKeyRevenueMetrics } from "./marketing-analytics-key-revenue-metrics";
import { MarketingAnalyticsMessagePerformance } from "./marketing-analytics-message-performance";
import { MarketingAnalyticsSentimentTopics } from "./marketing-analytics-sentiment-topics";

export const MarketingAnalyticsOverview = memo(
  function MarketingAnalyticsOverview({
    dateFilter,
    attributionDays,
    attributionEvents,
    channelFilter,
  }: {
    dateFilter: [Temporal.PlainDate, Temporal.PlainDate] | undefined;
    attributionDays: number;
    attributionEvents: MarketingAttributionEvent[];
    channelFilter: ChannelFilter;
  }) {
    return (
      <Flex dir="column" gap="4xl" pb="8xl" w="full">
        <MarketingAnalyticsKeyRevenueMetrics
          attributionDays={attributionDays}
          attributionEvents={attributionEvents}
          channelFilter={channelFilter}
          dateFilter={dateFilter}
        />
        <MarketingAnalyticsCampaignPerformance
          attributionDays={attributionDays}
          attributionEvents={attributionEvents}
          channelFilter={channelFilter}
          dateFilter={dateFilter}
        />
        <MarketingAnalyticsAutomationPerformance
          attributionDays={attributionDays}
          attributionEvents={attributionEvents}
          channelFilter={channelFilter}
          dateFilter={dateFilter}
        />
        <MarketingAnalyticsMessagePerformance
          attributionDays={attributionDays}
          attributionEvents={attributionEvents}
          channelFilter={channelFilter}
          dateFilter={dateFilter}
        />
        <MarketingAnalyticsSentimentTopics dateFilter={dateFilter} />
      </Flex>
    );
  },
);
